import Treasury from "../../assets/icons/Treasury.png";
import Account from "../../assets/icons/Accounts.png";
import E_Doc from "../../assets/icons/E-Doc.png";
import Wallets from "../../assets/icons/Wallets.png";
import { Link } from "react-router-dom";
import { useLanguage } from "../../i18n/LanguageContext";

const Card =
  "group w-full h-full border border-blue/20 rounded-2xl bg-white p-6 text-center shadow-md shadow-blue/10 transition-all duration-300 hover:shadow-xl hover:shadow-blue/20 hover:-translate-y-1 hover:border-blue/40 cursor-pointer";
const ImageDecorate = "w-12 lg:w-16 m-auto relative z-10";
const IconWrapper =
  "w-20 lg:w-24 h-20 lg:h-24 mx-auto mt-2 flex items-center justify-center rounded-2xl bg-blue/5 group-hover:bg-blue/10 transition-colors duration-300";

const TextDecorateInside = "text-blue font-bold text-lg md:text-xl pt-4";
const TextDecorationSpan =
  "text-sm text-darkBlue/60 text-center mt-3 leading-relaxed";

export const ProductCard_1 = () => {
  const { t } = useLanguage();
  return (
    <Link to="/products/treasury" className={Card}>
      <div className={IconWrapper}>
        <img alt="Treasury" src={Treasury} className={ImageDecorate} />
      </div>
      <p className={TextDecorateInside}>{t("home.cards.treasuryTitle")}</p>
      <p className={TextDecorationSpan}>{t("home.cards.treasuryDesc")}</p>
    </Link>
  );
};

export const ProductCard_2 = () => {
  const { t } = useLanguage();
  return (
    <Link to="/products/virtual-account" className={Card}>
      <div className={IconWrapper}>
        <img alt="Account" src={Account} className={ImageDecorate} />
      </div>
      <p className={TextDecorateInside}>{t("home.cards.vaTitle")}</p>
      <p className={TextDecorationSpan}>{t("home.cards.vaDesc")}</p>
    </Link>
  );
};

export const HeaderCard_3 = () => {
  return null;
};

export const ProductCard_4 = () => {
  const { t } = useLanguage();
  return (
    <Link to="/products/invoice-QR-Integration" className={Card}>
      <div className={IconWrapper}>
        <img alt="E_Doc" src={E_Doc} className={ImageDecorate} />
      </div>
      <p className={TextDecorateInside}>{t("home.cards.invoiceTitle")}</p>
      <p className={TextDecorationSpan}>{t("home.cards.invoiceDesc")}</p>
    </Link>
  );
};

export const ProductCard_5 = () => {
  const { t } = useLanguage();
  return (
    <Link to="/products/e-wallets" className={Card}>
      <div className={IconWrapper}>
        <img alt="Wallets" src={Wallets} className={ImageDecorate} />
      </div>
      <p className={TextDecorateInside}>{t("home.cards.walletsTitle")}</p>
      <p className={TextDecorationSpan}>{t("home.cards.walletsDesc")}</p>
    </Link>
  );
};

export const SolutionCard_1 = () => {
  const { t } = useLanguage();
  return (
    <div className={Card}>
      <div className={IconWrapper}>
        <span className="text-3xl">💳</span>
      </div>
      <p className={TextDecorateInside}>{t("home.cards.s1Title")}</p>
      <p className={TextDecorationSpan}>{t("home.cards.s1Desc")}</p>
    </div>
  );
};

export const SolutionCard_2 = () => {
  const { t } = useLanguage();
  return (
    <div className={Card}>
      <div className={IconWrapper}>
        <span className="text-3xl">📦</span>
      </div>
      <p className={TextDecorateInside}>{t("home.cards.s2Title")}</p>
      <p className={TextDecorationSpan}>{t("home.cards.s2Desc")}</p>
    </div>
  );
};

export const SolutionCard_3 = () => {
  const { t } = useLanguage();
  return (
    <div className={Card}>
      <div className={IconWrapper}>
        <span className="text-3xl">📊</span>
      </div>
      <p className={TextDecorateInside}>{t("home.cards.s3Title")}</p>
      <p className={TextDecorationSpan}>{t("home.cards.s3Desc")}</p>
    </div>
  );
};

export const SolutionCard_4 = () => {
  const { t } = useLanguage();
  return (
    <div className={Card}>
      <div className={IconWrapper}>
        <span className="text-3xl">💰</span>
      </div>
      <p className={TextDecorateInside}>{t("home.cards.s4Title")}</p>
      <p className={TextDecorationSpan}>{t("home.cards.s4Desc")}</p>
    </div>
  );
};

export const SolutionCard_5 = () => {
  const { t } = useLanguage();
  return (
    <div className={Card}>
      <div className={IconWrapper}>
        <span className="text-3xl">📋</span>
      </div>
      <p className={TextDecorateInside}>{t("home.cards.s5Title")}</p>
      <p className={TextDecorationSpan}>{t("home.cards.s5Desc")}</p>
    </div>
  );
};
